"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sacile": {
    "ce80f9ca": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "cavolano": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1c7e6b1": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "cornadella": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26844560": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "ronche": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ead03c39": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni-del-tempio": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "737052c2": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni-di-livenza": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "717b0c6e": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "720b2a21": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "sant-odorico": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eedef994": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "schiavoi": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4cf76756": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "topaligo": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf371b1f": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "villorba": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b616817c": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "skipSearch": false
    }],
    "vistorta": [{
      "hkey": "94e836b0",
      "slug": "sacile",
      "name": "Sacile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;